import { push } from '@lagunovsky/redux-react-router'
import { all, call, delay, put, takeLatest } from 'redux-saga/effects'

import { startLoading, stopLoading } from 'components/Loader/LoaderPopup/reducer'
import { setErrorMessage, setSuccessMessage } from 'components/Windows/CentralMessagesList/reducer'
import { callApiAsync } from 'services/api/callAPIAsync'
import { setAuthorized } from 'services/auth/reducer'
import { clearSession, setCookie } from 'services/token/helpers'
import { setRewards, setTransactions } from './components/CinestarClub/reducer'
import { setReservations, setTickets } from './components/TicketsAndReserv/reducer'
import { logout } from './reducer'

function* userLogoutSaga() {
    yield put(startLoading())
    const { error } = yield call(callApiAsync, 'logoutAuthorize')
    if (error) {
        yield put(stopLoading())
        console.error(error)
        yield put(setErrorMessage(error))
        return
    }
    yield put(setAuthorized(false))
    setCookie('profilePicture', '')
    // BE při deauthorize svůj REFRESH_TOKEN neruší, takže úklid session musí udělat FE –
    // jinak by po odhlášení zůstaly na stroji přihlašovací údaje platné 30 dní.
    clearSession()
    localStorage.setItem('userEmail', '')
    yield put(push('/login'))
    yield delay(10)

    //Delete users data after logout
    yield put(setTransactions([]))
    yield put(setRewards([]))
    yield put(setTickets([]))
    yield put(setReservations([]))

    yield put(stopLoading())
    yield put(setSuccessMessage('LOGOUT'))
}

export default function* userProfileSaga() {
    yield all([takeLatest(logout.type, userLogoutSaga)])
}
